<template>
  <div class="ia-rules-page">
    <section class="ia-rules-header">
      <div>
        <p class="ia-kicker">Painel IA IAN</p>
        <h1>Regras de Analise no Upload</h1>
      </div>
      <div class="ia-rules-actions">
        <v-btn outlined color="primary" @click="$router.push({ name: 'ia-coleta-evidencias.painel' })">
          Voltar
        </v-btn>
        <v-btn color="primary" @click="novaRegra">
          Nova regra
        </v-btn>
      </div>
    </section>

    <v-card outlined class="mb-4">
      <v-card-text>
        <v-row>
          <v-col cols="12" md="2">
            <v-select v-model="filtros.uf" :items="ufs" label="UF" outlined dense clearable />
          </v-col>
          <v-col cols="12" md="4">
            <v-autocomplete
              v-model="filtros.numeroQuesito"
              :items="quesitos"
              item-text="label"
              item-value="codigoQuesito"
              label="Quesito"
              outlined
              dense
              clearable
            />
          </v-col>
          <v-col cols="12" md="2">
            <v-select v-model="filtros.tipo" :items="tiposFiltro" label="Tipo" outlined dense clearable />
          </v-col>
          <v-col cols="12" md="2">
            <v-select v-model="filtros.escopo" :items="escoposFiltro" label="Escopo" outlined dense clearable />
          </v-col>
          <v-col cols="12" md="2" class="filter-actions">
            <v-btn color="primary" block :loading="loading" @click="carregarRegras">
              Filtrar
            </v-btn>
          </v-col>
        </v-row>
        <div v-if="quesitoSelecionado" class="selected-question">
          <div class="selected-question-code">{{ quesitoSelecionado.codigoQuesito }} - {{ quesitoSelecionado.tema }}</div>
          <div class="selected-question-text">{{ quesitoSelecionado.pergunta }}</div>
        </div>
      </v-card-text>
    </v-card>

    <v-data-table
      :headers="headers"
      :items="regras"
      :loading="loading"
      class="elevation-0 rules-table"
      no-data-text="Nenhuma regra encontrada."
      :items-per-page="15"
      :footer-props="{ itemsPerPageText: 'Linhas por pagina' }"
    >
      <template v-slot:item.tipo="{ item }">
        <v-chip small dark :color="item.tipo === 'ACEITACAO' ? 'green' : 'orange'">
          {{ item.tipo === 'ACEITACAO' ? 'Aceitacao' : 'Rejeicao' }}
        </v-chip>
      </template>
      <template v-slot:item.escopo="{ item }">
        {{ item.escopo === 'GERAL' ? 'Geral' : item.uf || 'UF' }}
      </template>
      <template v-slot:item.textoRegra="{ item }">
        <div class="rule-text">{{ item.textoRegra }}</div>
      </template>
      <template v-slot:item.ativo="{ item }">
        <v-icon :color="item.ativo ? 'green' : 'grey'">
          {{ item.ativo ? 'mdi-check-circle' : 'mdi-close-circle' }}
        </v-icon>
      </template>
      <template v-slot:item.acoes="{ item }">
        <v-btn icon small @click="editarRegra(item)" title="Editar regra">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon small :disabled="!item.ativo" @click="desativarRegra(item)" title="Desativar regra">
          <v-icon small color="red">mdi-delete-outline</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" max-width="760">
      <v-card>
        <v-card-title>{{ form.analiseIaUploadRegraId ? 'Editar regra' : 'Nova regra' }}</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="4">
              <v-select v-model="form.tipo" :items="tipos" label="Tipo" outlined dense />
            </v-col>
            <v-col cols="12" md="4">
              <v-select v-model="form.escopo" :items="escopos" label="Escopo" outlined dense />
            </v-col>
            <v-col cols="12" md="4">
              <v-select v-model="form.uf" :items="ufs" label="UF" outlined dense :disabled="form.escopo === 'GERAL'" />
            </v-col>
            <v-col cols="12" md="8">
              <v-autocomplete
                v-model="form.numeroQuesito"
                :items="quesitos"
                item-text="label"
                item-value="codigoQuesito"
                label="Quesito"
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model.number="form.prioridade" label="Prioridade" type="number" outlined dense />
            </v-col>
            <v-col v-if="formQuesitoSelecionado" cols="12">
              <div class="selected-question dialog-question">
                <div class="selected-question-code">{{ formQuesitoSelecionado.codigoQuesito }} - {{ formQuesitoSelecionado.tema }}</div>
                <div class="selected-question-text">{{ formQuesitoSelecionado.pergunta }}</div>
              </div>
            </v-col>
            <v-col cols="12">
              <v-combobox
                v-model="form.titulo"
                :items="titulosDisponiveis"
                label="Titulo"
                outlined
                dense
                clearable
              />
            </v-col>
            <v-col cols="12">
              <v-textarea v-model="form.textoRegra" label="Regra" outlined rows="5" auto-grow />
            </v-col>
            <v-col cols="12">
              <v-switch v-model="form.ativo" label="Ativa" inset />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="primary" :loading="saving" @click="salvarRegra">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { atualUfDefinition } from "../../../helpers/utils";
import { iaColetaEvidenciasApi } from "../services/api";

function resolveUfAtual() {
  const params = new URLSearchParams(window.location.search || "");
  const banco = params.get("banco") || localStorage.getItem("iaColetaBanco") || "";
  const match = /^ce-([a-z]{2})-hlg$/i.exec(banco);
  if (match) {
    return match[1].toUpperCase();
  }

  if (atualUfDefinition && atualUfDefinition.uf) {
    return String(atualUfDefinition.uf).toUpperCase();
  }

  return "TO";
}

function emptyForm(uf) {
  return {
    analiseIaUploadRegraId: null,
    numeroQuesito: null,
    tipo: "ACEITACAO",
    escopo: "UF",
    uf,
    ambiente: "hlg",
    titulo: "",
    textoRegra: "",
    prioridade: 100,
    ativo: true,
  };
}

export default {
  name: "IaColetaEvidenciasRegras",
  data() {
    const ufAtual = resolveUfAtual();
    return {
      loading: false,
      saving: false,
      dialog: false,
      regras: [],
      quesitos: [],
      ufs: [ufAtual],
      filtros: {
        uf: ufAtual,
        numeroQuesito: null,
        tipo: null,
        escopo: null,
      },
      form: emptyForm(ufAtual),
      tipos: [
        { text: "Aceitacao", value: "ACEITACAO" },
        { text: "Rejeicao", value: "REJEICAO" },
      ],
      tiposFiltro: [
        { text: "Aceitacao", value: "ACEITACAO" },
        { text: "Rejeicao", value: "REJEICAO" },
      ],
      titulosPorTipo: {
        ACEITACAO: [
          "Item minimo",
          "Costuma aceitar",
          "Evidencia documental forte",
          "Fonte oficial",
          "Comprovacao direta",
          "Indicador auditavel",
          "Equivalencia aceitavel",
          "Complemento recomendado",
        ],
        REJEICAO: [
          "Costuma recusar",
          "Sinal de rejeicao",
          "Nao recomendar quando",
          "Evidencia insuficiente",
          "Tema divergente",
          "Municipio divergente",
          "Documento sem validade",
          "Fonte fraca",
          "Falta de periodo",
          "Acao pontual",
        ],
      },
      escopos: [
        { text: "UF", value: "UF" },
        { text: "Geral", value: "GERAL" },
      ],
      escoposFiltro: [
        { text: "UF", value: "UF" },
        { text: "Geral", value: "GERAL" },
      ],
      headers: [
        { text: "Quesito", value: "numeroQuesito", width: 90 },
        { text: "Tipo", value: "tipo", width: 120 },
        { text: "Escopo", value: "escopo", width: 90 },
        { text: "Titulo", value: "titulo", width: 180 },
        { text: "Regra", value: "textoRegra" },
        { text: "Prioridade", value: "prioridade", width: 100 },
        { text: "Ativa", value: "ativo", width: 80 },
        { text: "Acoes", value: "acoes", sortable: false, width: 96 },
      ],
    };
  },
  async mounted() {
    await this.carregarQuesitos();
    await this.carregarRegras();
  },
  computed: {
    quesitoSelecionado() {
      return this.findQuesito(this.filtros.numeroQuesito);
    },
    formQuesitoSelecionado() {
      return this.findQuesito(this.form.numeroQuesito);
    },
    titulosDisponiveis() {
      return this.titulosPorTipo[this.form.tipo] || [];
    },
  },
  methods: {
    findQuesito(codigo) {
      if (!codigo) return null;
      return (this.quesitos || []).find((item) => String(item.codigoQuesito) === String(codigo)) || null;
    },
    async carregarQuesitos() {
      const data = await iaColetaEvidenciasApi.listarQuesitosRegras();
      this.quesitos = (data.quesitos || []).map((item) => ({
        ...item,
        label: `${item.codigoQuesito} - ${item.tema || item.pergunta || ""}`.trim(),
      }));
    },
    async carregarRegras() {
      this.loading = true;
      try {
        const data = await iaColetaEvidenciasApi.listarRegras({
          uf: this.filtros.uf,
          numeroQuesito: this.filtros.numeroQuesito,
          tipo: this.filtros.tipo,
          escopo: this.filtros.escopo,
          ativo: true,
        });
        this.regras = data.regras || [];
      } finally {
        this.loading = false;
      }
    },
    novaRegra() {
      this.form = emptyForm(this.filtros.uf || resolveUfAtual());
      this.form.numeroQuesito = this.filtros.numeroQuesito;
      this.dialog = true;
    },
    editarRegra(item) {
      this.form = {
        analiseIaUploadRegraId: item.analiseIaUploadRegraId,
        perguntaId: item.perguntaId,
        numeroQuesito: item.numeroQuesito,
        tipo: item.tipo,
        escopo: item.escopo,
        uf: item.uf || this.filtros.uf || resolveUfAtual(),
        ambiente: item.ambiente || "hlg",
        titulo: item.titulo || "",
        textoRegra: item.textoRegra || "",
        prioridade: item.prioridade || 100,
        ativo: item.ativo !== false,
      };
      this.dialog = true;
    },
    async salvarRegra() {
      this.saving = true;
      try {
        await iaColetaEvidenciasApi.salvarRegra(this.form);
        this.dialog = false;
        await this.carregarRegras();
      } finally {
        this.saving = false;
      }
    },
    async desativarRegra(item) {
      if (!window.confirm("Desativar esta regra?")) return;
      await iaColetaEvidenciasApi.desativarRegra(item.analiseIaUploadRegraId);
      await this.carregarRegras();
    },
  },
};
</script>

<style scoped>
.ia-rules-page {
  padding: 104px 24px 40px;
}

.ia-rules-header {
  align-items: flex-start;
  display: flex;
  gap: 24px;
  justify-content: space-between;
  margin-bottom: 20px;
}

.ia-rules-header h1 {
  font-size: 30px;
  font-weight: 800;
  margin: 0;
}

.ia-kicker {
  color: #666;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
  margin: 0 0 6px;
  text-transform: uppercase;
}

.ia-rules-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-end;
}

.filter-actions {
  align-items: center;
  display: flex;
}

.rules-table {
  border: 1px solid #e0e0e0;
}

.rule-text {
  line-height: 1.35;
  max-width: 720px;
  white-space: normal;
}

.selected-question {
  background: #f7f8fa;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  margin-top: 14px;
  padding: 12px 14px;
}

.dialog-question {
  margin-top: 0;
}

.selected-question-code {
  color: #555;
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 4px;
}

.selected-question-text {
  color: #222;
  font-size: 14px;
  line-height: 1.45;
  white-space: normal;
}

@media (max-width: 760px) {
  .ia-rules-page {
    padding: 88px 14px 28px;
  }

  .ia-rules-header {
    display: block;
  }

  .ia-rules-actions {
    justify-content: flex-start;
    margin-top: 14px;
  }
}
</style>
